import mapResponseToLicense, {
  mapResponseToService,
} from '../mappers/mapResponseToLicense'
import isSameDate from '../../../utils/Date/isSameDate'
import { IData } from './response'

export function mapLicencesResponse(item1, item2, subs, user) {
  try {
    const license = item2.items.map(l => {
      const lic = mapResponseToLicense(l, user)

      if(lic.source === 'fakturownia') {
        return {
          ...lic,
          sub: subs.find(s => {
            return s.last_license.license === lic.rawLicense && s.status_extended !== 'CANCELLED'
          }),
        }
      }

      return lic

    })
    const service = Object.entries(item1.items[0].services).map(entries =>
      mapResponseToService(entries[1], entries[0]),
    )

    return [
      ...license.map(license => {
        if (
          service.find(
            service =>
              service.licenseType === license.licenseType &&
              isSameDate(service.license as Date, license.license as Date),
          )
        ) {
          return {
            ...license,
            ...service.find(
              service =>
                service.licenseType === license.licenseType &&
                isSameDate(service.license as Date, license.license as Date),
            ),
            roomLimit: license.roomLimit,
            startLicense: license.startLicense,
          }
        }
        return license
      }),
      ...service.filter(
        s =>
          !license.find(
            service =>
              service.licenseType === s.licenseType &&
              isSameDate(service.license as Date, s.license as Date),
          ),
      ),]
  } catch (e) {
    console.error(e)
  }

}

export default async function(integrations: Response, licences: Response, user:any) {
  const json2: IData = await integrations.json()
  const json: IData = await licences.json()
  const license = json.items.map(item =>  mapResponseToLicense(item, user))

  const service = Object.entries(json2.items[0].services).map(entries =>
    mapResponseToService(entries[1], entries[0]),
  )

  return [
    ...license.map(license => {
      if (
        service.find(
          service =>
            service.licenseType === license.licenseType &&
            isSameDate(service.license as Date, license.license as Date),
        )
      ) {
        return {
          ...license,
          ...service.find(
            service =>
              service.licenseType === license.licenseType &&
              isSameDate(service.license as Date, license.license as Date),
          ),
          roomLimit: license.roomLimit,
          startLicense: license.startLicense,
        }
      }
      return { ...license, status: license.active }
    }),
    ...service.filter(
      s =>
        !license.find(
          service =>
            service.licenseType === s.licenseType &&
            isSameDate(service.license as Date, s.license as Date),
        ),
    ),
  ]
}
